module.exports = __webpack_public_path__ + "img/vertical_4_6_6000.81c9894f.png";